export default __webpack_public_path__ + "static/media/logo_dark_x.ea4b6d33.svg";